import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 13v-6l-5 4l-5 -4v6l5 4l5 -4","key":"svg-0"}]]

/**
 * IconArrowBadgeDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmFkZ2UtZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTcgMTN2LTZsLTUgNGwtNSAtNHY2bDUgNGw1IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-badge-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBadgeDown = createReactComponent('outline', 'arrow-badge-down', 'ArrowBadgeDown', __iconNode);

export default IconArrowBadgeDown;